<template>
	<div id="dorm_right1">
		<div class="main-value noback_list">
			<dv-scroll-board :config="config" style="width:100%;height:100%" />
		</div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgId = storage.getItem("orgId");
var buildIds = storage.getItem("buildIds");
export default {
	data() {
		return {
			config: {
				time: '00:00:00', // 每天几点执行
				interval: 1, // 隔几天执行一次
				runNow: true, // 是否立即执行
				intervalTimer: '',
				timeOutTimer: ''
			}
		};
	},
	mounted() {
		this.initData();
		this.createTimer();
	},
	beforeDestroy() {
		console.log(
			'关闭任务定时器',
			this.config.intervalTimer
		)
		clearInterval(this.config.intervalTimer)
		console.log('清除定时器timeout', this.config.timeOutTimer)
		clearTimeout(this.config.timeOutTimer)
	},
	methods: {
		createTimer() {
			if (this.config.runNow) {
				this.runTimer()		// 如果配置了立刻运行则立刻运行任务函数
			}
			// 获取下次要执行的时间，如果执行时间已经过了今天，就让把执行时间设到明天的按时执行的时间
			var nowTime = new Date().getTime()
			var timePoint = this.config.time.split(':').map((i) => parseInt(i))
			var recent = new Date().setHours(...timePoint) // 获取执行时间的时间戳
			if (recent <= nowTime) {
				recent += 24 * 60 * 60 * 1000
			}
			// 未来程序执行的时间减去现在的时间，就是程序要多少秒之后执行
			var doRunTime = recent - nowTime
			this.config.timeOutTimer = setTimeout(this.setTimer, doRunTime)
		},
		setTimer() {
			console.log('进入定时器')
			this.runTimer()
			// 每隔多少天再执行一次
			var intTime = this.config.interval * 24 * 60 * 60 * 1000
			this.config.intervalTimer = setInterval(this.runTimer, intTime)
		},
		runTimer() {
			console.log("正在执行定时任务.......ing.....")
			this.initData();
		},
		initData() {
			let _this = this;
			this.$http.get("/dataView/dorm/wgUsers?orgId=" + orgId + "&buildIds=" + buildIds).then(res => {
				if (res.data.code === 200) {
					var result = [];
					for (let i = 0; i < res.data.result.length; i++) {
						var record = res.data.result[i];
						result.push([record.studentName, record.className, record.dormName, record
							.attendDate]);
					}
					var config = {
						header: ['姓名', '班级', '宿舍号', '未归日期'],
						data: result,
						headerBGC: '',
						oddRowBGC: 'none',
						evenRowBGC: 'none',
						headerHeight: 40,
						columnWidth: [80, 120],
						rowNum: 7,
						waitTime: 2000,
						hoverPause: false
					};
					_this.config = config;
				}
			});
		}
	}
};
</script>

<style lang="scss">
#dorm_right1 {
	height: 100%;

	.noback_list {
		margin-top: 0.3rem;
		padding: 0.3rem 0.2rem;
	}

	.noback_list .header {
		background: url("../../assets/img/table_bg.png") center repeat-y;
		background-size: 150%;
		color: #00f0ff;
		font-size: 0.2rem;
		font-weight: bold;
	}

	.noback_list .row-item {
		background: url("../../assets/img/table_bg.png") bottom no-repeat;
		background-size: 160%;
		color: #00f0ff;
		font-size: 0.19rem;
	}

	.dv-scroll-board {
		padding: 10px;
	}

	.dv-scroll-board .header .header-item,
	.dv-scroll-board .rows .ceil {
		padding: 0 5px;
	}

	.noback_list .row-item span {
		color: #ff5959
	}

	@media screen and (min-width: 768px) and (max-width: 992px) {}

	@media screen and (min-width: 1200px) and (max-width: 1920px) {}
}
</style>
